export default __webpack_public_path__ + "static/media/guest.fd4058ea.gif";